import StyledTextarea from "./styled";

export default StyledTextarea;
